/**
 * @flow
 * @relayHash 4e5c4b8370e2b6f02fa4af60b842b88f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddItemMovementModal_item$ref = any;
type AddUpdateItemModal_defaultForm$ref = any;
type AddUpdateItemModal_item$ref = any;
type DeleteItemModal_item$ref = any;
type ItemCostAnalysis_item$ref = any;
type ItemLots_itemLotEdges$ref = any;
type ItemSidePanel_item$ref = any;
type ItemSubComponentsTree_itemChildEdges$ref = any;
type ItemTransactionLog_item$ref = any;
export type FormType = "ITEM" | "JOB_STEP" | "JOB_TASK" | "JOB_YIELD";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type ItemQueryVariables = {|
  id: string
|};
export type ItemQueryResponse = {|
  +item: {|
    +id: string,
    +name: string,
    +itemNumber: string,
    +bomNumber: ?string,
    +description: ?string,
    +createdAt: any,
    +lotTracking: ?boolean,
    +totalQty: number,
    +safetyQuantity: ?number,
    +totalValue: ?number,
    +cost: ?number,
    +calculatedMachineCost: ?number,
    +calculatedMaterialCost: ?number,
    +totalCalculatedCost: ?number,
    +quantityUOM: {|
      +id: string,
      +name: string,
      +symbol: string,
    |},
    +childItems: {|
      +edges: ?$ReadOnlyArray<?{|
        +$fragmentRefs: ItemSubComponentsTree_itemChildEdges$ref
      |}>
    |},
    +lots: {|
      +edges: ?$ReadOnlyArray<?{|
        +$fragmentRefs: ItemLots_itemLotEdges$ref
      |}>
    |},
    +$fragmentRefs: ItemSidePanel_item$ref & AddUpdateItemModal_item$ref & DeleteItemModal_item$ref & ItemTransactionLog_item$ref & AddItemMovementModal_item$ref & ItemCostAnalysis_item$ref,
  |},
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
    +company: {|
      +name: ?string
    |},
  |},
  +forms: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +type: FormType,
        +$fragmentRefs: AddUpdateItemModal_defaultForm$ref,
      |}
    |}>
  |},
|};
export type ItemQuery = {|
  variables: ItemQueryVariables,
  response: ItemQueryResponse,
|};
*/


/*
query ItemQuery(
  $id: ID!
) {
  item(id: $id) {
    id
    name
    itemNumber
    bomNumber
    description
    createdAt
    lotTracking
    totalQty
    safetyQuantity
    totalValue
    cost
    calculatedMachineCost
    calculatedMaterialCost
    totalCalculatedCost
    quantityUOM {
      id
      name
      symbol
    }
    childItems {
      edges {
        ...ItemSubComponentsTree_itemChildEdges
        cursor
        node {
          __typename
          id
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    lots {
      edges {
        ...ItemLots_itemLotEdges
        cursor
        node {
          __typename
          id
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    ...ItemSidePanel_item
    ...AddUpdateItemModal_item
    ...DeleteItemModal_item
    ...ItemTransactionLog_item
    ...AddItemMovementModal_item
    ...ItemCostAnalysis_item
  }
  viewer {
    id
    permissions
    company {
      name
      id
    }
  }
  forms(types: [ITEM]) {
    edges {
      node {
        id
        type
        ...AddUpdateItemModal_defaultForm
      }
    }
  }
}

fragment ItemSubComponentsTree_itemChildEdges on ItemChildEdge {
  usageQty
  bomType
  referenceDesignator
  findNumber
  notes
  isPhantom
  scrapFactor
  leadTimeOffsetDays
  isBackflush
  workflowStateId
  fixedQuantity
  isOptional
  selectionGroup
  isDefaultSelection
  optionLabel
  minQuantity
  maxQuantity
  priceAdjustment
  isCustomerVisible
  salesDisplayName
  componentPrice
  discountPercent
  sortOrder
  isShippedSeparately
  isReplaceable
  serviceIntervalDays
  meanTimeBetweenFailure
  repairMethod
  serviceNotes
  isCriticalSpare
  node {
    id
    itemNumber
    name
    description
    partNumber
    upc
    cost
    totalCalculatedCost
    quantityUOM {
      id
      symbol
    }
    category {
      id
      name
    }
  }
}

fragment ItemLots_itemLotEdges on ItemLotEdge {
  quantity
  node {
    id
    lotNumber
    binNumber
    quantity
    expiresAt
  }
  ...ItemLotsTable_itemLotEdges
}

fragment ItemSidePanel_item on Item {
  id
  itemNumber
  upc
  weight
  dimensionWidth
  dimensionLength
  dimensionHeight
  partNumber
  description
  safetyQuantity
  category {
    id
    name
  }
  quantityUOM {
    id
    name
    symbol
  }
  weightUOM {
    id
    symbol
  }
  dimensionUOM {
    id
    symbol
  }
  lotTracking
  defaultLocation {
    id
    name
  }
  cost
  formFieldValues
  form {
    id
    ...FormBuilder_form
    fields {
      id
      systemKey
      name
      type
    }
  }
}

fragment AddUpdateItemModal_item on Item {
  id
  name
  upc
  partNumber
  bomNumber
  description
  category {
    id
    name
  }
  quantityUOM {
    id
    name
    type
    symbol
  }
  weightUOM {
    id
    name
    type
    symbol
  }
  dimensionUOM {
    id
    name
    type
    symbol
  }
  form {
    id
    name
    type
    systemKey
    productionType {
      id
    }
    fields {
      id
      systemKey
      type
      name
      description
      placeholder
      isRequired
      isCreatable
      applicationType
      displayOrder
      properties
      options {
        name
        value
        id
      }
      ...AdditionalFieldInfo_formField
    }
  }
  formFieldValues
  dimensionLength
  dimensionWidth
  dimensionHeight
  weight
  lotTracking
  cost
  sellingPrice
  safetyQuantity
  totalValue
  defaultLocation {
    id
    name
  }
}

fragment DeleteItemModal_item on Item {
  id
  name
}

fragment ItemTransactionLog_item on Item {
  id
  itemNumber
  quantityUOM {
    id
    name
  }
  logs {
    id
    user {
      id
    }
    lot {
      id
      lotNumber
      binNumber
      expiresAt
    }
    fromLot {
      id
      lotNumber
      binNumber
      expiresAt
    }
    operation
    quantity
    createdAt
    notes
  }
  lots {
    edges {
      quantity
      node {
        id
        lotNumber
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  lotTracking
  ...AddItemMovementModal_item
}

fragment AddItemMovementModal_item on Item {
  id
  itemNumber
  totalQty
  quantityUOM {
    id
    name
  }
  logs {
    id
    user {
      id
    }
    lot {
      id
    }
    fromLot {
      id
    }
    operation
    quantity
    notes
    createdAt
  }
  lots {
    edges {
      quantity
      node {
        id
        lotNumber
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  lotTracking
}

fragment ItemCostAnalysis_item on Item {
  id
  name
  cost
  calculatedMachineCost
  calculatedMaterialCost
  totalCalculatedCost
  costHistory(daysBack: 90) {
    calculatedMachineCost
    calculatedMaterialCost
    totalCalculatedCost
    targetCost
    snapshotDate
  }
  childItems {
    edges {
      node {
        id
        itemNumber
        name
        cost
        totalCalculatedCost
        __typename
      }
      usageQty
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AddUpdateItemModal_defaultForm on Form {
  id
  type
  name
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment AdditionalFieldInfo_formField on FormField {
  id
  name
  type
}

fragment FormBuilder_form on Form {
  id
  name
  type
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment ItemLotsTable_itemLotEdges on ItemLotEdge {
  quantity
  node {
    id
    lotNumber
    binNumber
    quantity
    expiresAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "itemNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "bomNumber",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lotTracking",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalQty",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "safetyQuantity",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalValue",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "calculatedMachineCost",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "calculatedMaterialCost",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCalculatedCost",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "permissions",
  "args": null,
  "storageKey": null
},
v22 = [
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "ITEM"
    ]
  }
],
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "partNumber",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "upc",
  "args": null,
  "storageKey": null
},
v27 = [
  (v2/*: any*/),
  (v3/*: any*/)
],
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCategory",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lotNumber",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "binNumber",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expiresAt",
  "args": null,
  "storageKey": null
},
v33 = [
  (v2/*: any*/),
  (v16/*: any*/),
  (v3/*: any*/),
  (v23/*: any*/)
],
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
},
v35 = [
  (v2/*: any*/)
],
v36 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productionType",
  "storageKey": null,
  "args": null,
  "concreteType": "ProductionType",
  "plural": false,
  "selections": (v35/*: any*/)
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "fields",
  "storageKey": null,
  "args": null,
  "concreteType": "FormField",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v34/*: any*/),
    (v23/*: any*/),
    (v3/*: any*/),
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isRequired",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCreatable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "applicationType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "properties",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "options",
      "storageKey": null,
      "args": null,
      "concreteType": "FormFieldOption",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        },
        (v2/*: any*/)
      ]
    }
  ]
},
v38 = [
  (v2/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ItemQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Item",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "quantityUOM",
            "storageKey": null,
            "args": null,
            "concreteType": "UOM",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v16/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "childItems",
            "name": "__Item_childItems_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemChildConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemChildEdge",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": (v19/*: any*/)
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "ItemSubComponentsTree_itemChildEdges",
                    "args": null
                  }
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "lots",
            "name": "__Item_lots_connection",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemLotConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemLotEdge",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Lot",
                    "plural": false,
                    "selections": (v19/*: any*/)
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "ItemLots_itemLotEdges",
                    "args": null
                  }
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ItemSidePanel_item",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "AddUpdateItemModal_item",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DeleteItemModal_item",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ItemTransactionLog_item",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "AddItemMovementModal_item",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ItemCostAnalysis_item",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v21/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v22/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "AddUpdateItemModal_defaultForm",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ItemQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Item",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "quantityUOM",
            "storageKey": null,
            "args": null,
            "concreteType": "UOM",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v16/*: any*/),
              (v23/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "childItems",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemChildConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemChildEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "usageQty",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "bomType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "referenceDesignator",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "findNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isPhantom",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "scrapFactor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "leadTimeOffsetDays",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isBackflush",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "workflowStateId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fixedQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isOptional",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "selectionGroup",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isDefaultSelection",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "optionLabel",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "minQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "maxQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "priceAdjustment",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCustomerVisible",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesDisplayName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "componentPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "discountPercent",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sortOrder",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isShippedSeparately",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isReplaceable",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serviceIntervalDays",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "meanTimeBetweenFailure",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "repairMethod",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serviceNotes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isCriticalSpare",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v12/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "quantityUOM",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UOM",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v16/*: any*/)
                        ]
                      },
                      (v28/*: any*/),
                      (v18/*: any*/)
                    ]
                  },
                  (v17/*: any*/)
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "childItems",
            "args": null,
            "handle": "connection",
            "key": "Item_childItems",
            "filters": []
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "childItems",
            "args": null,
            "handle": "connection",
            "key": "ItemCostAnalysis_childItems",
            "filters": []
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "lots",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemLotConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemLotEdge",
                "plural": true,
                "selections": [
                  (v29/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Lot",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v29/*: any*/),
                      (v32/*: any*/),
                      (v18/*: any*/)
                    ]
                  },
                  (v17/*: any*/)
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "lots",
            "args": null,
            "handle": "connection",
            "key": "Item_lots",
            "filters": []
          },
          (v26/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "weight",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dimensionWidth",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dimensionLength",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dimensionHeight",
            "args": null,
            "storageKey": null
          },
          (v25/*: any*/),
          (v28/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "weightUOM",
            "storageKey": null,
            "args": null,
            "concreteType": "UOM",
            "plural": false,
            "selections": (v33/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "dimensionUOM",
            "storageKey": null,
            "args": null,
            "concreteType": "UOM",
            "plural": false,
            "selections": (v33/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "defaultLocation",
            "storageKey": null,
            "args": null,
            "concreteType": "WarehouseLocation",
            "plural": false,
            "selections": (v27/*: any*/)
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "formFieldValues",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "form",
            "storageKey": null,
            "args": null,
            "concreteType": "Form",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v23/*: any*/),
              (v34/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "sellingPrice",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "logs",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemTransactionLog",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": (v35/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lot",
                "storageKey": null,
                "args": null,
                "concreteType": "Lot",
                "plural": false,
                "selections": (v38/*: any*/)
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "fromLot",
                "storageKey": null,
                "args": null,
                "concreteType": "Lot",
                "plural": false,
                "selections": (v38/*: any*/)
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "operation",
                "args": null,
                "storageKey": null
              },
              (v29/*: any*/),
              (v7/*: any*/),
              (v24/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "costHistory",
            "storageKey": "costHistory(daysBack:90)",
            "args": [
              {
                "kind": "Literal",
                "name": "daysBack",
                "value": 90
              }
            ],
            "concreteType": "ItemCostHistory",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "targetCost",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "snapshotDate",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v21/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "forms",
        "storageKey": "forms(types:[\"ITEM\"])",
        "args": (v22/*: any*/),
        "concreteType": "FormConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "FormEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Form",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v23/*: any*/),
                  (v3/*: any*/),
                  (v34/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ItemQuery",
    "id": null,
    "text": "query ItemQuery(\n  $id: ID!\n) {\n  item(id: $id) {\n    id\n    name\n    itemNumber\n    bomNumber\n    description\n    createdAt\n    lotTracking\n    totalQty\n    safetyQuantity\n    totalValue\n    cost\n    calculatedMachineCost\n    calculatedMaterialCost\n    totalCalculatedCost\n    quantityUOM {\n      id\n      name\n      symbol\n    }\n    childItems {\n      edges {\n        ...ItemSubComponentsTree_itemChildEdges\n        cursor\n        node {\n          __typename\n          id\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    lots {\n      edges {\n        ...ItemLots_itemLotEdges\n        cursor\n        node {\n          __typename\n          id\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    ...ItemSidePanel_item\n    ...AddUpdateItemModal_item\n    ...DeleteItemModal_item\n    ...ItemTransactionLog_item\n    ...AddItemMovementModal_item\n    ...ItemCostAnalysis_item\n  }\n  viewer {\n    id\n    permissions\n    company {\n      name\n      id\n    }\n  }\n  forms(types: [ITEM]) {\n    edges {\n      node {\n        id\n        type\n        ...AddUpdateItemModal_defaultForm\n      }\n    }\n  }\n}\n\nfragment ItemSubComponentsTree_itemChildEdges on ItemChildEdge {\n  usageQty\n  bomType\n  referenceDesignator\n  findNumber\n  notes\n  isPhantom\n  scrapFactor\n  leadTimeOffsetDays\n  isBackflush\n  workflowStateId\n  fixedQuantity\n  isOptional\n  selectionGroup\n  isDefaultSelection\n  optionLabel\n  minQuantity\n  maxQuantity\n  priceAdjustment\n  isCustomerVisible\n  salesDisplayName\n  componentPrice\n  discountPercent\n  sortOrder\n  isShippedSeparately\n  isReplaceable\n  serviceIntervalDays\n  meanTimeBetweenFailure\n  repairMethod\n  serviceNotes\n  isCriticalSpare\n  node {\n    id\n    itemNumber\n    name\n    description\n    partNumber\n    upc\n    cost\n    totalCalculatedCost\n    quantityUOM {\n      id\n      symbol\n    }\n    category {\n      id\n      name\n    }\n  }\n}\n\nfragment ItemLots_itemLotEdges on ItemLotEdge {\n  quantity\n  node {\n    id\n    lotNumber\n    binNumber\n    quantity\n    expiresAt\n  }\n  ...ItemLotsTable_itemLotEdges\n}\n\nfragment ItemSidePanel_item on Item {\n  id\n  itemNumber\n  upc\n  weight\n  dimensionWidth\n  dimensionLength\n  dimensionHeight\n  partNumber\n  description\n  safetyQuantity\n  category {\n    id\n    name\n  }\n  quantityUOM {\n    id\n    name\n    symbol\n  }\n  weightUOM {\n    id\n    symbol\n  }\n  dimensionUOM {\n    id\n    symbol\n  }\n  lotTracking\n  defaultLocation {\n    id\n    name\n  }\n  cost\n  formFieldValues\n  form {\n    id\n    ...FormBuilder_form\n    fields {\n      id\n      systemKey\n      name\n      type\n    }\n  }\n}\n\nfragment AddUpdateItemModal_item on Item {\n  id\n  name\n  upc\n  partNumber\n  bomNumber\n  description\n  category {\n    id\n    name\n  }\n  quantityUOM {\n    id\n    name\n    type\n    symbol\n  }\n  weightUOM {\n    id\n    name\n    type\n    symbol\n  }\n  dimensionUOM {\n    id\n    name\n    type\n    symbol\n  }\n  form {\n    id\n    name\n    type\n    systemKey\n    productionType {\n      id\n    }\n    fields {\n      id\n      systemKey\n      type\n      name\n      description\n      placeholder\n      isRequired\n      isCreatable\n      applicationType\n      displayOrder\n      properties\n      options {\n        name\n        value\n        id\n      }\n      ...AdditionalFieldInfo_formField\n    }\n  }\n  formFieldValues\n  dimensionLength\n  dimensionWidth\n  dimensionHeight\n  weight\n  lotTracking\n  cost\n  sellingPrice\n  safetyQuantity\n  totalValue\n  defaultLocation {\n    id\n    name\n  }\n}\n\nfragment DeleteItemModal_item on Item {\n  id\n  name\n}\n\nfragment ItemTransactionLog_item on Item {\n  id\n  itemNumber\n  quantityUOM {\n    id\n    name\n  }\n  logs {\n    id\n    user {\n      id\n    }\n    lot {\n      id\n      lotNumber\n      binNumber\n      expiresAt\n    }\n    fromLot {\n      id\n      lotNumber\n      binNumber\n      expiresAt\n    }\n    operation\n    quantity\n    createdAt\n    notes\n  }\n  lots {\n    edges {\n      quantity\n      node {\n        id\n        lotNumber\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  lotTracking\n  ...AddItemMovementModal_item\n}\n\nfragment AddItemMovementModal_item on Item {\n  id\n  itemNumber\n  totalQty\n  quantityUOM {\n    id\n    name\n  }\n  logs {\n    id\n    user {\n      id\n    }\n    lot {\n      id\n    }\n    fromLot {\n      id\n    }\n    operation\n    quantity\n    notes\n    createdAt\n  }\n  lots {\n    edges {\n      quantity\n      node {\n        id\n        lotNumber\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  lotTracking\n}\n\nfragment ItemCostAnalysis_item on Item {\n  id\n  name\n  cost\n  calculatedMachineCost\n  calculatedMaterialCost\n  totalCalculatedCost\n  costHistory(daysBack: 90) {\n    calculatedMachineCost\n    calculatedMaterialCost\n    totalCalculatedCost\n    targetCost\n    snapshotDate\n  }\n  childItems {\n    edges {\n      node {\n        id\n        itemNumber\n        name\n        cost\n        totalCalculatedCost\n        __typename\n      }\n      usageQty\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AddUpdateItemModal_defaultForm on Form {\n  id\n  type\n  name\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment AdditionalFieldInfo_formField on FormField {\n  id\n  name\n  type\n}\n\nfragment FormBuilder_form on Form {\n  id\n  name\n  type\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment ItemLotsTable_itemLotEdges on ItemLotEdge {\n  quantity\n  node {\n    id\n    lotNumber\n    binNumber\n    quantity\n    expiresAt\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "item",
            "childItems"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "item",
            "lots"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4ab62bdd50b1a7209899e808c1d74cb3';
module.exports = node;
